declare global {
  interface Window {
    __env__?: {
      VITE_API_BASE_URL?: string
      VITE_APPINSIGHTS_CONNECTION_STRING?: string
      VITE_SPA_BUILD?: string
      VITE_ENV_NAME?: string
      VITE_SESSION_HINT_COOKIE?: string
    }
  }
}

// Prefer values injected at deploy time via /env-config.js, fall back to
// values baked in at build time via Vite's import.meta.env (used in local dev).
export const runtimeEnv = {
  get VITE_API_BASE_URL(): string {
    return window.__env__?.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || ''
  },
  get VITE_APPINSIGHTS_CONNECTION_STRING(): string {
    return (
      window.__env__?.VITE_APPINSIGHTS_CONNECTION_STRING ||
      import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ||
      ''
    )
  },
  get VITE_SPA_BUILD(): string {
    return window.__env__?.VITE_SPA_BUILD || ''
  },
  get VITE_ENV_NAME(): string {
    return window.__env__?.VITE_ENV_NAME || import.meta.env.VITE_ENV_NAME || ''
  },
  /** Must match the API's CookieOptions:SessionHintCookieName for the same environment. */
  get VITE_SESSION_HINT_COOKIE(): string {
    return window.__env__?.VITE_SESSION_HINT_COOKIE || 'cmmi-session'
  },
}
